import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isObject from '@cotyorg/ccx-utils/js/helpers/isObject';
import NavigationLink from '@cotyorg/ccx-molecules/NavigationLink';
import NavigationTopLevel from '../NavigationTopLevel';
import NavigationContainer from '../../containers/NavigationContainer';

const NestedListComponent = ({ page, selectedSlug }) => {
  const listItemClassName = classNames(
    'navigation__list-item',
    'navigation__list-item--nested',
    'navigation-streamlined__list-item',
  );

  if (!isObject(page) && !Array.isArray(page.pages)) {
    return null;
  }

  return (
    <div className="navigation__list-container">
      <div className="grid-container">
        <ul className="navigation__list navigation-streamlined__list navigation__list--nested">
          {
            page.pages.map(({
              slug,
              name,
              pages,
              url,
              openInNewWindow,
            }) => (
              <li key={slug} className={listItemClassName} data-test="navigation-streamlined">
                <NavigationLink
                  extraClass="navigation__link navigation__link--nested"
                  textExtraClass="navigation__link-text navigation__link-text--nested"
                  name={name}
                  pages={pages}
                  url={url}
                  selected={slug === selectedSlug}
                  openInNewWindow={openInNewWindow}
                />
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
};

NestedListComponent.propTypes = {
  page: PropTypes.shape({
    pages: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      pages: PropTypes.array,
    })),
  }),
  selectedSlug: PropTypes.string,
};

const NavigationStreamlined = () => (
  <NavigationContainer
    extraClass="navigation-streamlined"
    NestedListComponent={NestedListComponent}
    childComponent={NavigationTopLevel}
  />
);

export default NavigationStreamlined;
